var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 321.757,
    height: 312.517,
    viewBox: "0 0 321.757 312.517",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_276",
    "data-name": "Groupe 276",
    transform: "translate(-763.382 -481.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_73",
    "data-name": "Trac\\xE9 73",
    d: "M423.951,361.383l-8.286,3.371c-.355.636-.735,1.268-1.142,1.877A71.94,71.94,0,0,1,406.691,377q-8.173,8.973-13.534,8.973c-3.066,0-4.588-2.789-4.588-8.338q0-9.927,2.786-28.007l8.365-58.346a142,142,0,0,0,1.8-20.6q0-20.11-15.564-20.124-15.7,0-35.76,20.046-20.039,20.075-34.646,50.411l2.154-19.666,1.569-14.474c.838-7.753,1.268-12.822,1.268-15.256q0-21.064-14.624-21.061-30.376,0-65.593,56.773l-4.41,6.919,1.292-11.154L238.5,292.4l1.268-12.751c.506-4.943.786-8.871.786-11.783q0-17.3-13.561-17.311-10.071,0-27.3,16.272-17.26,16.27-17.26,25.724c0,1.47,1.217,3.193,3.624,5.172q13.727-26.73,25.549-26.715c3.347,0,5.042,3.347,5.042,10.06a146.735,146.735,0,0,1-1.114,15.715l-.937,8.341-8.061,72.966-1.268,11.024-1.241,11.633-.482,4.41,14.245-5.8,8.286-3.4.991-.4.15-1.473,1.648-15.28,2.229-20.986q2.969-26.731,22.254-56.319,19.275-29.54,33.76-29.552,9.276,0,9.274,15.26c0,3.979-.2,8.057-.608,12.265l-1.114,8.009-7.907,70.611-1.114,11.024-1.268,11.633-.455,4.41,23.365-9.6,4.184-37.739q2.964-26.731,22.48-56.319,19.541-29.54,34.266-29.552,8.784,0,8.8,13.359a94.767,94.767,0,0,1-.786,10.389c-.533,4.512-.885,7.705-1.091,9.582-.53,4.611-.913,7.6-1.114,8.973l-5.6,37.89q-3.461,23.761-3.449,35.077,0,17.947,13.407,17.943,10.42,0,28.031-16.675,3.615-3.42,6.464-6.539Q424.012,369.776,424,361.889a4.1,4.1,0,0,0-.051-.506",
    transform: "translate(580.943 284.072)",
    fill: "#793321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_74",
    "data-name": "Trac\\xE9 74",
    d: "M430.724,388.686Q417,415.412,405.178,415.425c-3.374,0-5.046-3.371-5.046-10.088a152.216,152.216,0,0,1,1.091-15.714l.964-8.337,8.057-72.966,1.244-11,1.265-11.66.482-4.382-14.245,5.8-8.286,3.374-.988.4-.154,1.47-1.648,15.308-2.229,20.962q-3,26.766-22.278,56.315t-33.733,29.552c-6.211,0-9.3-5.07-9.3-15.256,0-3.979.226-8.061.632-12.269l1.115-8.009,7.907-70.608,1.118-11,1.241-11.66.482-4.382L309.5,290.854l-4.181,37.739q-2.969,26.766-22.507,56.315-19.505,29.54-34.266,29.552-8.784,0-8.772-13.356a95.737,95.737,0,0,1,.786-10.392c.509-4.512.889-7.705,1.09-9.578.533-4.615.889-7.606,1.115-8.973l5.575-37.89q3.461-23.762,3.473-35.08,0-17.942-13.407-17.916-10.414,0-28.031,16.651c-2.407,2.28-4.587,4.485-6.464,6.563q-11.137,12.168-11.151,20.022a2.049,2.049,0,0,0,.075.533l8.29-3.4c.356-.632.735-1.265,1.138-1.873a72.683,72.683,0,0,1,7.832-10.368q8.138-8.932,13.537-8.946c3.039,0,4.587,2.762,4.587,8.314q0,9.922-2.789,28.007l-8.365,58.342a138.691,138.691,0,0,0-1.8,20.606q0,20.111,15.561,20.124,15.7,0,35.764-20.049,20.034-20.034,34.646-50.412l-2.181,19.67-1.569,14.47q-1.256,11.635-1.244,15.26,0,21.059,14.624,21.061,30.34,0,65.593-56.773l4.41-6.919-1.292,11.178-1.292,10.693-1.268,12.723a116.14,116.14,0,0,0-.786,11.811q0,17.3,13.537,17.287,10.071,0,27.32-16.272t17.236-25.724c0-1.473-1.193-3.2-3.6-5.172",
    transform: "translate(605.904 358.377)",
    fill: "#793321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_75",
    "data-name": "Trac\\xE9 75",
    d: "M234.132,255.064l-5.5-13.578-.191.079-7.469,15.783-1.668.68-16.4-6.116-.191.079,5.5,13.581-3.357,1.36L198.1,250.258l4.454-1.8,16.22,6.071.1-.038,7.555-15.714,4.311-1.747,6.762,16.675Z",
    transform: "translate(618.808 251.363)",
    fill: "#793321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_76",
    "data-name": "Trac\\xE9 76",
    d: "M240.281,251.806l-4.328-3.849-18.265,2.858-2.991,5-4.317.677,12.47-20.251,4.112-.646,17.762,15.516Zm-20.716-4.147,13.667-2.143-7.965-7.131-.15.021Z",
    transform: "translate(648.518 247.896)",
    fill: "#793321"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_509",
    "data-name": "Rectangle 509",
    width: 3.624,
    height: 17.992,
    transform: "translate(896.03 481.789) rotate(-1.176)",
    fill: "#793321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_77",
    "data-name": "Trac\\xE9 77",
    d: "M248.306,240a63.912,63.912,0,0,0-10.19-1.938c-5.534-.506-9.028-.489-9.2,1.33s3.542,2.574,7.893,3.336l2.567.465c5.391.984,10.8,2.355,10.46,6.047-.366,4-4.041,5.449-13.91,4.547a49.422,49.422,0,0,1-12.354-2.6l.769-2.721a52.437,52.437,0,0,0,12.341,2.7c5.281.482,8.932.4,9.144-1.88.174-1.948-3.548-2.755-7.9-3.538l-2.137-.4c-5.517-.995-11.219-2.263-10.884-5.958.342-3.74,4.242-4.83,13.653-3.972a58.53,58.53,0,0,1,10.474,1.914Z",
    transform: "translate(680.433 246.809)",
    fill: "#793321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_78",
    "data-name": "Trac\\xE9 78",
    d: "M247.448,256.381c-10.819-3.265-16.528-7.78-14.624-14.094s9.158-6.915,19.977-3.648c10.867,3.278,16.573,7.8,14.668,14.1s-9.154,6.912-20.022,3.637m4.608-15.28c-8.375-2.53-14.139-2.328-15.537,2.3-1.374,4.56,3.3,7.982,11.671,10.508s14.2,2.3,15.585-2.287c1.395-4.611-3.34-8-11.718-10.525",
    transform: "translate(701.922 250.556)",
    fill: "#793321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_79",
    "data-name": "Trac\\xE9 79",
    d: "M266.184,268.785l-12.809-24.144-.133-.079-7.25,12.7-3.128-1.784,8.932-15.653,3.688,2.106,12.587,23.751.113.062,7.134-12.5,3.131,1.788-8.932,15.653Z",
    transform: "translate(727.077 258.14)",
    fill: "#793321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_80",
    "data-name": "Trac\\xE9 80",
    d: "M276.274,283.917l10.778-9.941-.144-.154-17.417-1.429-1.22-1.326-.058-17.513-.14-.15L257.3,263.348l-2.461-2.67,13.236-12.207,3.265,3.535.027,17.331.072.075,17.379,1.538,3.155,3.422L278.736,286.58Z",
    transform: "translate(756.027 279.042)",
    fill: "#793321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_81",
    "data-name": "Trac\\xE9 81",
    d: "M277.3,286.561l2.068-5.418-9.179-16.073-5.739-1.022-2.167-3.8,23.385,4.471,2.068,3.62-8.2,22.141ZM273.816,265.7l6.868,12.029,3.842-9.989-.079-.133Z",
    transform: "translate(774.049 307.511)",
    fill: "#793321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_82",
    "data-name": "Trac\\xE9 82",
    d: "M274.583,295.441l4.386-10.224-3.319-10.2-6.974,2.266-1.121-3.449,17.123-5.572,5.377,16.518c1.719,5.282,1.231,8.608-2.171,9.712-3.107,1.012-5.866-.226-7.357-4.478l-4.338,10.368Zm8.529-22.852-4.82,1.566,4.2,12.922c1.162,3.569,2.29,4.365,4.023,3.8,1.665-.54,1.887-2.02.779-5.422Z",
    transform: "translate(786.79 326.903)",
    fill: "#793321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_83",
    "data-name": "Trac\\xE9 83",
    d: "M270.215,280.393l17.82-2.5.506,3.593-15.021,2.106,2.807,20.039-2.8.393Z",
    transform: "translate(793.224 350.19)",
    fill: "#793321"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_510",
    "data-name": "Rectangle 510",
    width: 17.994,
    height: 3.627,
    transform: "translate(1066.408 657.632) rotate(-1.709)",
    fill: "#793321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_84",
    "data-name": "Trac\\xE9 84",
    d: "M270.8,315.784l16.89-21.451.017-.154-14.528-1.494.366-3.583,17.906,1.843-.434,4.222L274.4,316.256l-.014.126,14.3,1.473-.369,3.583-17.906-1.846Z",
    transform: "translate(793.689 377.309)",
    fill: "#793321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_85",
    "data-name": "Trac\\xE9 85",
    d: "M274.9,299.368l17.246,5.244-6.905,22.722-2.711-.827,5.852-19.246-4.29-1.3-4.987,16.412-2.711-.827,4.991-16.408-4.834-1.47-5.849,19.246L268,322.087Z",
    transform: "translate(787.856 402.134)",
    fill: "#793321"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBanner);
export default __webpack_public_path__ + "static/media/LogoBanner.eebf3d0ad9f5587ab4ec471d15fa94e7.svg";
export { ForwardRef as ReactComponent };